import axios from 'axios'

const HTTP = axios.create({
  // withCredentials: false,

})

export default HTTP
